<template>
  <div class="auth">
    <!-- CMS LAYOUT — sidebar, mobile header, top header, and page content -->
    <vmc-sidebar />
    <vmc-mobile-header />
    <vmc-header />

    <!-- PAGE TRANSITION — out-in mode prevents dual-element layout shifts -->
    <transition name="fade" mode="out-in">
      <router-view :key="$route.path"></router-view>
    </transition>
  </div>
</template>

<script>
// COMPONENT IMPORTS
import VMCSidebarCMS from '../components/VMCSidebarCMS';
import VMCMobileHeaderCMS from '../components/VMCMobileHeaderCMS';
import VMCHeaderCMS from '../components/VMCHeaderCMS';

export default {
  name: "adminCMS",

  // COMPONENT REGISTRATION
  components: {
    'vmc-sidebar': VMCSidebarCMS,
    'vmc-mobile-header': VMCMobileHeaderCMS,
    'vmc-header': VMCHeaderCMS,
  },

  data() {
    return {
      // INACTIVITY TIMER — tracks the timeout reference so it can be cleared/reset
      inactivityTimer: null,

      // Change inactivity timeout here — time in milliseconds
      inactivityLimit: 60 * 60 * 1000,

      // ACTIVITY EVENTS — these user actions reset the inactivity timer
      activityEvents: ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'],
    }
  },

  mounted() {
    // AUTH CHECK — redirect to login if no token found
    const token = localStorage.getItem('vmc_token');
    if (!token) {
      this.$router.push('/auth/login');
      return;
    }

    // CHECK REMEMBER ME FLAG - only start timer if they didn't check the box
    const staySignedIn = localStorage.getItem('vmc_remember') === 'true';
    if (!staySignedIn) {
      this.startInactivityWatcher();
    }
  },

  beforeDestroy() {
    // CLEANUP — remove all activity listeners and clear timer when component is destroyed
    this.stopInactivityWatcher();
  },

  methods: {
    // INACTIVITY WATCHER — attaches activity event listeners to the window
    startInactivityWatcher() {
      this.activityEvents.forEach(event => {
        window.addEventListener(event, this.resetInactivityTimer);
      });

      // Start the initial timer
      this.resetInactivityTimer();
    },

    // STOP WATCHER — removes all event listeners and clears the timer
    stopInactivityWatcher() {
      this.activityEvents.forEach(event => {
        window.removeEventListener(event, this.resetInactivityTimer);
      });
      clearTimeout(this.inactivityTimer);
    },

    // RESET TIMER — called every time user activity is detected
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.logoutDueToInactivity();
      }, this.inactivityLimit);
    },

    // AUTO LOGOUT — clears token and redirects to login after inactivity
    logoutDueToInactivity() {
      localStorage.removeItem('vmc_token');
      localStorage.removeItem('vmc_user');
      localStorage.removeItem('vmc_profile');
      this.stopInactivityWatcher();
      this.$router.push('/auth/login?reason=inactivity');
    },
  }
};
</script>

<style>
/* GLOBAL BUTTON STYLES */
button {
  outline: none;
  transition: 0.3s;
}

/* BUTTON HOVER STATES */
.vmc-bg-prime-6:hover {
  background-color: var(--vmc-primary-8);
}

.vmc-bg-prime-5:hover {
  background-color: var(--vmc-primary-7);
}

.vmc-bg-prime-4:hover {
  background-color: var(--vmc-primary-6);
}

/* PAGE TRANSITION — FADE ONLY */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

/* Removed absolute positioning to keep element in document flow */
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>